import React, { Fragment } from 'react';
export const renderTextWithLinks = (text: string): React.ReactNode => {
  // Regex to detect URLs (http://, https://, www.)
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
  const parts = text.split(urlRegex);
  return parts.map((part, index) => {
    if (part.match(urlRegex)) {
      // Ensure URL has protocol
      const href = part.startsWith('http') ? part : `https://${part}`;
      return <a key={index} href={href} target="_blank" rel="noopener noreferrer" className="text-primary hover:text-primary/80 underline transition-colors" onClick={e => e.stopPropagation()} data-id="element-221">
          {part}
        </a>;
    }
    return <Fragment key={index} data-id="element-222">{part}</Fragment>;
  });
};